import { render, staticRenderFns } from "./_facebook-dialog.vue?vue&type=template&id=9d6d052a&scoped=true"
import script from "./_facebook-dialog.vue?vue&type=script&lang=js"
export * from "./_facebook-dialog.vue?vue&type=script&lang=js"
import style0 from "./_facebook-dialog.vue?vue&type=style&index=0&id=9d6d052a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6d052a",
  null
  
)

export default component.exports